import React, { Component } from 'react'
import './AcceptableTerms.css'
// let acceptableterms = 'Details not available'
class AcceptableTerms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            acceptableterms: 'Details not available'
        }
    }

    // componentWillReceiveProps(nextProps){
    //     acceptableterms=nextProps.transporter_data.acceptable_terms;
    //     if(acceptableterms==undefined || acceptableterms==null){
    //         acceptableterms='Details not available'

    //     }
    // }   

    static getDerivedStateFromProps(nextProps, prevState) {
        // acceptableterms = nextProps.transporter_data.acceptable_terms;
        // if (acceptableterms === undefined || acceptableterms === null) {
        //     acceptableterms = 'Details not available'
        // }

        if (nextProps.transporter_data.acceptable_terms === undefined || nextProps.transporter_data.acceptable_terms === null) {
            return {
                acceptableterms: 'Details not available'
            }
        }
        else {
            return {
                acceptableterms: nextProps.transporter_data.acceptable_terms
            }
        }
    }

    render() {
        const { acceptableterms } = this.state
        return (
            <div className="acceptabletermscard">
                <div className="acceptabletermscontainer row" id="style-2">
                    <div className="col-12">
                        <span className="data_header"><b>Acceptable Terms</b></span>
                        {(acceptableterms === 'Details not available') ? (<div className="acceptabletermsparagraph">Details not available</div>) : (<div className="acceptabletermsparagraph">
                            {(acceptableterms.payment_terms) ? (<p className="acc_term"><b>Payment Terms: </b>{acceptableterms.payment_terms} </p>) : ('')}
                            {(acceptableterms.cargo_insured) ? (<p className="acc_term"><b>Cargo Insured by Customer: </b> {acceptableterms.cargo_insured}</p>) : ('')}
                            {(acceptableterms.loading_unloading_charges) ? (<p className="acc_term"><b>Loading/Unloading charges by Customer: </b> {acceptableterms.loading_unloading_charges}</p>) : ('')}
                            {(acceptableterms.detention_charges) ? (<p className="acc_term"><b>Detention Charges: </b> {acceptableterms.detention_charges}</p>) : ('')}
                            {(acceptableterms.other_terms) ? (<p className="acc_term"><b>Other Terms: </b> {acceptableterms.other_terms}</p>) : ('')}
                        </div>)}
                    </div>

                </div>
            </div>
        )
    }
}

export default AcceptableTerms
